module.exports = __webpack_public_path__ + "static/media/smallFactory.b007b43a.png";